import { computed } from "vue";
import { useAuthStore } from "@/stores/authStore";

/** Permission helpers for employee self-service dashboard widgets. */
export function useEmployeeDashboardAccess() {
  const auth = useAuthStore();

  function hasPermission(permission) {
    if (!permission) return false;
    return typeof auth.can === "function" ? auth.can(permission) : false;
  }

  const user = computed(() => auth.user || auth.currentUser || {});

  const firstName = computed(() => {
    const u = user.value;
    const raw = u?.first_name || u?.name || "";
    return String(raw).trim().split(/\s+/)[0] || "there";
  });

  const companyName = computed(() => {
    const u = user.value;
    return (
      u?.company?.company_name ||
      u?.employee?.company?.company_name ||
      u?.company_name ||
      ""
    );
  });

  const showPayrollSelfService = computed(
    () =>
      hasPermission("Payroll.ReadSelf") || hasPermission("Payroll.Read"),
  );

  const canLoadPayslipSnapshot = computed(() =>
    hasPermission("Payroll.ReadSelf"),
  );

  const showAttendanceDashboard = computed(
    () =>
      hasPermission("Attendance.Read") ||
      hasPermission("Attendance.Create"),
  );

  const showLeaveSelfService = computed(
    () => hasPermission("Leaves.Read") || hasPermission("Leaves.Create"),
  );

  const showProjectsTasks = computed(
    () => hasPermission("Task.Read") || hasPermission("Project.Read"),
  );

  const showTickets = computed(() => hasPermission("Ticket.Read"));

  const showPolicies = computed(() => hasPermission("Policy.Read"));

  const showMinimalHint = computed(
    () =>
      !showPayrollSelfService.value &&
      !showAttendanceDashboard.value &&
      !showProjectsTasks.value &&
      !showLeaveSelfService.value,
  );

  return {
    hasPermission,
    firstName,
    companyName,
    showPayrollSelfService,
    canLoadPayslipSnapshot,
    showAttendanceDashboard,
    showLeaveSelfService,
    showProjectsTasks,
    showTickets,
    showPolicies,
    showMinimalHint,
  };
}
